import { Helmet }     from 'react-helmet';
import { useContext } from 'preact/hooks';

import { routes }    from '../data/routes.js';
import GlobalContext from '../context/GlobalContext.js';

const Canonical = ({route, page = null}) => {
  const { pathroot, primaryDomain } = useContext(GlobalContext);
  const parsedRoute = routes[route].de
  if (pathroot === '') {
    if (parsedRoute === '/') {
      return (
        <Helmet>
          <link rel="canonical" href={`https://${primaryDomain}`}/>
        </Helmet>
      )
    }
    return (
      <Helmet>
        <link rel="canonical" href={`https://${primaryDomain}${parsedRoute}${page !== null ? `/${page}` : ''}`}/>
      </Helmet>
    )
  } else {
    return (
      <Helmet>
        <link rel="canonical" href={`https://${primaryDomain}/${pathroot}${parsedRoute}${page !== null ? `/${page}` : ''}`}/>
      </Helmet>
    )
  }
};

export default Canonical;
